import { Menu, MenuItem } from '@mui/material';
import styled from 'styled-components/macro';

import { uiColors } from '../../common/styles';
import { PHONE_WIDTH } from '../../common/pixels';

export const StyledMenu = styled(Menu)`
    ul {
        padding-top: 0px;
        padding-bottom: 0px;
    }
    @media (min-width: ${PHONE_WIDTH}}) {
        li {
            font-size: 14px;
            color: ${uiColors.PRIMARY_TEXT};
        }
    }
    z-index: 5000 !important;
    position: fixed;
`;

export const StyledMenuItem = styled(MenuItem)`
    
    &.MuiMenuItem-root {
        min-height: auto;
        font-weight: 300;
        font-size: 20px;
    }
    &.Mui-selected {
        color: ${uiColors.PRIMARY_500};
        background-color: ${uiColors.WHITE} !important;
    }
`;
